"use client";
import { usePathname } from "next/navigation";
import Script from "next/script";
import { useEffect } from "react";

const NEXT_PUBLIC_MEASUREMENT_ID = process.env.NEXT_PUBLIC_MEASUREMENT_ID;

export const trackEvent = (eventName, eventParams) => {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", eventName, eventParams);
  }
};

const Analytics = () => {
  const pathname = usePathname();

  useEffect(() => {
    if (!NEXT_PUBLIC_MEASUREMENT_ID) return;

    const trackPageView = () => {
      if (window.gtag) {
        window.gtag("event", "page_view", {
          page_path: pathname,
        });
      }
    };

    trackPageView();
  }, [pathname]);

  if (!NEXT_PUBLIC_MEASUREMENT_ID) return null;

  return (
    <>
      {/* Load Google Analytics script */}
      <Script
        async
        src={`https://www.googletagmanager.com/gtag/js?id=${NEXT_PUBLIC_MEASUREMENT_ID}`}
      />
      {/* Google Analytics initialization */}
      <Script id="google-analytics" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${NEXT_PUBLIC_MEASUREMENT_ID}', {
            page_path: window.location.pathname,
          });
        `}
      </Script>
    </>
  );
};

export default Analytics;
